import React from "react";
import "./styles.scss";
import menuSvg from "../../../icons/menu.svg";
import logoYWLarge from "../../../icons/LuxYW-name.svg";
import logoYW from "../../../icons/LuxYW-logo.svg";
import NavToggleMenu  from "../NavToggleMenu/NavToggleMenu";

import {PortalHeaderProps} from "./props";
import {useHeaderMenuOverlay, useLanguageCurrencyPicker} from "./hooks/headerHooks";
import LanguageCurrencyFullScreen
  from "../LanguageCurrencyPicker/components/LanguageCurrencyFullScreen/LanguageCurrencyFullScreen";
import Picker from "../LanguageCurrencyPicker/components/Picker/Picker";
import {HeaderCenteredElement} from "./components/HeaderCenteredElement";
import {HeaderEndElement} from "./components/HeaderEndElement";

function PortalHeader({
  menuHeaderTitle,
  portalLogoLink,
  portalLogoSmall,
  portalLogoSmallAlt,
  portalLogoLarge,
  portalLogoLargeAlt,
  desktopEndContainer,
  navigationLinks,
  languageCurrencyPicker,
  onClick,
  searchBox,
  centeredContainer,
  menuIcon = menuSvg
}: PortalHeaderProps) {

  const {navMenuRef, handleMenuClick, focusedSearch, handleFocusChange, handleOverlayClick, onCloseMenu} = useHeaderMenuOverlay(onClick);
  const {fullScreenRef, handleButtonClick, handleFullScreenClick, toggleProps} = useLanguageCurrencyPicker(languageCurrencyPicker, onClick);
  const searching = focusedSearch ? " portal-header__searching" : "";

  return (
    <>
      <NavToggleMenu
        ref={navMenuRef}
        headerTitle={menuHeaderTitle}
        navigationLinks={navigationLinks || []}
        languageCurrencyToggle={toggleProps}
        onLanguageCurrencyFullScreenClick={handleFullScreenClick}
        handleOverlayClick={handleOverlayClick}
        onCloseMenu={onCloseMenu} />
      <LanguageCurrencyFullScreen
        ref={fullScreenRef}
        headerTitle={languageCurrencyPicker?.title || ''}>
        <Picker
          items={languageCurrencyPicker?.items}
          buttonOnClick={handleButtonClick}
          buttonText={languageCurrencyPicker?.buttonText || ''}
          title={languageCurrencyPicker?.title || ''}
          hideCurrency={languageCurrencyPicker?.hideCurrency || false}
      />
      </LanguageCurrencyFullScreen>
      <div className="portal-header" data-e2e="portal-header">
        <div className={`portal-header__container${searching}`}>
          <button className="portal-header__menu-button" onClick={handleMenuClick} type="button">
            <img src={menuIcon} alt="Menu Icon" />
          </button>
          <div className="portal-header__logo">
            <a href={portalLogoLink || "#"} className='portal-header__logo-link' >
              <img
                className='portal-header__logo--small'
                src={portalLogoSmall || logoYW}
                alt={portalLogoSmallAlt || "Portal Link"} />
                <img
                className='portal-header__logo--large'
                src={portalLogoLarge || logoYWLarge}
                alt={portalLogoLargeAlt || "Portal Link"} />
            </a>
          </div>
          <div className="portal-header__container-search">
            <HeaderCenteredElement
              searchBox={searchBox}
              handleFocusChange={handleFocusChange}
              focusedSearch={focusedSearch}
              centeredContainer={centeredContainer} />
          </div>
          <div className='portal-header__container-desktop-end'>
            <HeaderEndElement desktopEndContainer={desktopEndContainer} />
          </div>
          </div>
        </div>
    </>
  );
}

export default React.memo(PortalHeader);
